// extracted by mini-css-extract-plugin
export var content = "layout-module--content--99b97";
export var wrapper = "layout-module--wrapper--82e27";